<script lang="ts" setup>
import { Button } from '@forgd/ui-kit/button'
import { ArrowLeftIcon } from '@heroicons/vue/24/outline'

const route = useRoute()
</script>

<template>
  <NuxtLoadingIndicator />
  <NuxtLayout name="dashboard" cta="Streamline your operations & improve your Leaderboard rank by providing data to Forgd.">
    <template v-if="route.name !== 'my-active-engagements'" #header>
      <div class="flex gap-2 items-center">
        <Button as-child variant="outline" size="sm">
          <NuxtLink to="/my-active-engagements">
            <ArrowLeftIcon aria-hidden="true" />
            Back
          </NuxtLink>
        </Button>
        <span class="font-semibold">
          Engagement Details
        </span>
      </div>
    </template>
    <slot />
  </NuxtLayout>
</template>
